// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1KL89","inner":"Form_inner__1gIL9","range":"Form_range__kC9Lt","name":"Form_name__1DAzc","actions":"Form_actions__3yvSy"};